<template>
  <div id="app">
	<AmbientParticles/>
    <transition name="page" mode="out-in"><router-view/></transition>
	<el-backtop></el-backtop>
  </div>
</template>

<script>import AmbientParticles from './components/common/AmbientParticles.vue'; export default {components:{AmbientParticles}}</script>

<style>
	#app {
		min-height:100vh;background:#f7f2e9;color:#382c25;position:relative;
	}
	#app > :not(.ambient-particles){position:relative;z-index:1}.page-enter-active,.page-leave-active{transition:opacity .28s ease,transform .28s ease}.page-enter{opacity:0;transform:translateY(10px)}.page-leave-to{opacity:0;transform:translateY(-6px)}
</style>
